<div
  #modalRoot
  class="provider-tx-modal gw-flex gw-max-h-[95vh] gw-flex-col gw-gap-small gw-overflow-y-auto gw-p-medium"
>
  <ng-container *ngIf="isProviderTransactions">
    <div class="provider-tx-header-grid">
      <div class="provider-tx-header-cell">
        <!-- Summary + webhook -->
        <div
          class="provider-tx-topbar gw-rounded-xl gw-border gw-border-solid gw-border-border-normal gw-bg-background-elevation-2 gw-px-medium gw-py-small"
        >
          <div class="provider-tx-topbar__recipient">
            <span
              class="gw-inline-flex gw-h-9 gw-w-9 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-lg gw-bg-background-neutral-2"
            >
              <gatewee-icon
                icon="@phi.arrows-left-right"
                size="16px"
                iconStyle="primary"
                weight="bold"
              ></gatewee-icon>
            </span>
            <div class="gw-min-w-0">
              <p
                class="gw-mb-0 gw-truncate gw-text-sm gw-font-semibold gw-text-text-primary"
              >
                {{ recipient?.name }}
              </p>
              <p class="gw-mb-0 gw-truncate gw-text-xs gw-text-text-secondary">
                #{{ recipient?.id }} · {{ recipient?.provider }}
              </p>
            </div>
          </div>

          <div *ngIf="webhookResendEnabled" class="provider-tx-topbar__webhook">
            <button
              type="button"
              class="provider-tx-topbar__info gw-inline-flex gw-shrink-0 gw-cursor-pointer gw-items-center gw-justify-center gw-rounded gw-p-2x-small hover:gw-opacity-80"
              [tuiHint]="
                'features.recipients.providerTransactions.sections.webhookDisclaimer'
                  | translate
              "
              tuiHintDirection="top"
              [attr.aria-label]="
                'features.recipients.providerTransactions.sections.webhookDisclaimer'
                  | translate
              "
            >
              <gatewee-icon
                icon="@phi.info"
                size="14px"
                iconStyle="primary"
                weight="bold"
              ></gatewee-icon>
            </button>
            <gatewee-select-v3
              class="provider-tx-topbar__webhook-select"
              [items]="dataKeys"
              [(ngModel)]="selectedKeyForWebhook"
              [placeholder]="
                'features.recipients.providerTransactions.keyForWebhook'
                  | translate
              "
              height="44px"
            ></gatewee-select-v3>
          </div>

          <span
            *ngIf="showTotalCount"
            class="provider-tx-topbar__count gw-inline-flex gw-shrink-0 gw-items-center gw-rounded-full gw-bg-background-neutral-2 gw-px-small gw-py-2x-small gw-text-xs gw-font-medium gw-text-text-secondary"
          >
            {{
              'features.recipients.providerTransactions.summary.records'
                | translate : {count: totalRecords}
            }}
          </span>
          <span
            *ngIf="!showTotalCount && page > 0"
            class="provider-tx-topbar__count gw-inline-flex gw-shrink-0 gw-items-center gw-rounded-full gw-bg-background-neutral-2 gw-px-small gw-py-2x-small gw-text-xs gw-font-medium gw-text-text-secondary"
          >
            {{ 'common.paginationPage' | translate : {page: page} }}
          </span>
        </div>
      </div>

      <div class="provider-tx-header-cell">
        <!-- Filters -->
        <details
          #filterDetails
          class="provider-tx-collapsible gw-gatewee-collapsible-details gw-min-w-0 gw-overflow-hidden gw-rounded-xl gw-border gw-border-solid gw-border-border-normal gw-bg-background-elevation-2"
        >
          <summary
            class="provider-tx-collapsible__summary gw-cursor-pointer gw-select-none gw-px-medium gw-py-small gw-outline-none gw-transition-colors gw-duration-200 hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
          >
            <span class="provider-tx-collapsible__lead">
              <span
                class="gw-inline-flex gw-h-9 gw-w-9 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-lg gw-bg-background-neutral-2"
              >
                <gatewee-icon
                  icon="@phi.funnel"
                  size="16px"
                  iconStyle="primary"
                  weight="bold"
                ></gatewee-icon>
              </span>
              <div class="gw-min-w-0">
                <p
                  class="gw-mb-0 gw-truncate gw-text-sm gw-font-semibold gw-text-text-primary"
                >
                  {{
                    'features.recipients.providerTransactions.sections.filters'
                      | translate
                  }}
                  <span
                    *ngIf="activeFilterCount > 0"
                    class="gw-ml-2x-small gw-inline-flex gw-shrink-0 gw-rounded-full gw-bg-background-neutral-2 gw-px-2x-small gw-py-3x-small gw-align-middle gw-text-[10px] gw-font-medium gw-text-text-secondary"
                  >
                    {{ activeFilterCount }}
                  </span>
                </p>
                <p
                  class="gw-mb-0 gw-truncate gw-text-xs gw-text-text-secondary"
                >
                  {{
                    'features.recipients.providerTransactions.sections.filtersHint'
                      | translate
                  }}
                </p>
              </div>
            </span>
            <gatewee-expand-chevron
              [expanded]="filterDetails.open"
              size="16px"
              class="gw-inline-flex gw-shrink-0 gw-text-text-secondary"
            ></gatewee-expand-chevron>
          </summary>

          <div class="gw-gatewee-collapsible-panel">
            <div
              class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-bg-background-elevation-3 gw-px-small gw-pb-small gw-pt-small"
            >
              <div class="provider-tx-filters">
                <div class="provider-tx-search-row">
                  <gatewee-select-v3
                    [label]="
                      'features.recipients.providerTransactions.searchBy'
                        | translate
                    "
                    [items]="searchTermOptions"
                    [(ngModel)]="searchTerm"
                    [placeholder]="
                      'features.recipients.providerTransactions.searchBy'
                        | translate
                    "
                  ></gatewee-select-v3>

                  <div class="provider-tx-field">
                    <label class="gw-form-label gw-h-[16px]">{{
                      'features.recipients.providerTransactions.searchPlaceholder'
                        | translate
                    }}</label>
                    <div class="provider-tx-field__control">
                      <input
                        type="text"
                        class="gw-input-base"
                        [placeholder]="
                          'features.recipients.providerTransactions.searchPlaceholder'
                            | translate
                        "
                        [(ngModel)]="searchValue"
                        (keyup.enter)="applyFilters()"
                      />
                    </div>
                  </div>
                </div>

                <div class="provider-tx-report-row">
                  <gatewee-datepicker-v2
                    inputId="provider-tx-report-start"
                    [label]="
                      'features.recipients.providerTransactions.report.startDate'
                        | translate
                    "
                    [(ngModel)]="reportFilters.startDate"
                  ></gatewee-datepicker-v2>

                  <gatewee-datepicker-v2
                    inputId="provider-tx-report-end"
                    [label]="
                      'features.recipients.providerTransactions.report.endDate'
                        | translate
                    "
                    [(ngModel)]="reportFilters.endDate"
                  ></gatewee-datepicker-v2>

                  <gatewee-select-v3
                    [label]="
                      'features.recipients.providerTransactions.report.transactionType'
                        | translate
                    "
                    [items]="transactionTypeOptions"
                    [(ngModel)]="selectedTransactionType"
                    [placeholder]="
                      'features.recipients.providerTransactions.report.transactionTypeAll'
                        | translate
                    "
                  ></gatewee-select-v3>

                  <div class="provider-tx-field provider-tx-field--inline">
                    <span
                      class="gw-form-label gw-h-[16px] gw-invisible"
                      aria-hidden="true"
                      >.</span
                    >
                    <div
                      class="provider-tx-field__control provider-tx-report-actions"
                    >
                      <gatewee-checkbox
                        [(ngModel)]="reportFilters.onlyConfirmed"
                        [label]="
                          'features.recipients.providerTransactions.report.onlyConfirmed'
                            | translate
                        "
                        labelFontSize="12"
                        size="s"
                      ></gatewee-checkbox>
                      <gatewee-button
                        type="button"
                        variant="primary"
                        size="s"
                        iconName="@phi.funnel"
                        [title]="'common.filters.submit' | translate"
                        (clicked)="applyFilters()"
                      ></gatewee-button>
                      <gatewee-button
                        type="button"
                        variant="secondary"
                        size="s"
                        [title]="'common.filters.remove' | translate"
                        [disabled]="!hasActiveFilters"
                        (clicked)="onFiltersClear()"
                      ></gatewee-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </details>
      </div>
    </div>
  </ng-container>

  <!-- Results -->
  <section class="provider-tx-results gw-min-h-0 gw-flex-1">
    <div *ngIf="showResultsToolbar" class="provider-tx-results__toolbar">
      <p
        *ngIf="showHiddenColumnsHint"
        class="provider-tx-results__hint gw-mb-0"
      >
        {{
          'features.recipients.providerTransactions.summary.hiddenColumns'
            | translate
              : {
                  visible: visibleDataColumnCount,
                  total: totalDataColumnCount
                }
        }}
      </p>

      <div *ngIf="isProviderTransactions" class="provider-tx-results__export">
        <gatewee-button
          type="button"
          variant="primary"
          size="s"
          iconName="@phi.download-simple"
          [title]="
            'features.recipients.providerTransactions.report.generateReport'
              | translate
          "
          (clicked)="onExportReportClick()"
        ></gatewee-button>
      </div>
    </div>

    <div>
      <gatewee-table-v2
        *ngIf="showTable; else emptyState"
        [data]="data.records || []"
        [columns]="columns"
        [page]="page"
        [pageSize]="pageSize"
        [total]="totalRecords"
        [hasMore]="hasMorePages"
        [showSettings]="true"
        [size]="tableSize"
        [tableId]="identifier + '-table'"
        (newPage)="pageChange($any($event))"
        (pageSizeChange)="pageSizeChange($event)"
        (outClick)="onRowAction($any($event))"
      ></gatewee-table-v2>
    </div>

    <ng-template #emptyState>
      <div
        class="gw-flex gw-min-h-[8rem] gw-flex-col gw-items-center gw-justify-center gw-gap-2x-small gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
      >
        <gatewee-icon
          icon="@phi.magnifying-glass"
          size="1.5rem"
          iconStyle="secondary"
          weight="regular"
        ></gatewee-icon>
        <p class="gw-mb-0 gw-text-sm gw-text-text-secondary">
          {{ 'common.dataNotFound' | translate }}
        </p>
      </div>
    </ng-template>
  </section>
</div>
